import { cva } from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        // Jetons de statut (index.css) : couples fond / encre garantis AA dans
        // les deux thèmes (#88). Pas de couleurs Tailwind en dur ici.
        success:
          'border-transparent bg-success text-success-foreground hover:bg-success/80',
        warning:
          'border-transparent bg-warning text-warning-foreground hover:bg-warning/80',
        error: 'border-transparent bg-error text-error-foreground hover:bg-error/80',
        // Version discrète, posée sur une carte : une teinte légère de l'état et
        // son encre `*-text`, épinglée AA sur cette teinte (#307). L'aplat plein
        // criait sur chaque carte, surtout en sombre.
        successSubtle: 'border-transparent bg-success/15 text-success-text',
        warningSubtle: 'border-transparent bg-warning/15 text-warning-text',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)
